import Naluri from '~/common/api/naluri';
import {
  COMMON_RESEND_FAILED_BROADCAST_BEGIN,
  COMMON_RESEND_FAILED_BROADCAST_SUCCESS,
  COMMON_RESEND_FAILED_BROADCAST_FAILURE,
  COMMON_RESEND_FAILED_BROADCAST_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function resendFailedBroadcast(broadcast_id) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: COMMON_RESEND_FAILED_BROADCAST_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = Naluri.post(`/api/expert/v2/broadcasts/${broadcast_id}/resent_failed`);
      doRequest.then(
        res => {
          dispatch({
            type: COMMON_RESEND_FAILED_BROADCAST_SUCCESS,
            data: [res],
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: COMMON_RESEND_FAILED_BROADCAST_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissResendFailedBroadcastError() {
  return {
    type: COMMON_RESEND_FAILED_BROADCAST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_RESEND_FAILED_BROADCAST_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getResendFailedBroadcastPending: true,
        getResendFailedBroadcastError:   null,
      };

    case COMMON_RESEND_FAILED_BROADCAST_SUCCESS:
      // The request is success
      const broadcastListing = state.broadcastListing.withMutations(broadcast =>
        action.data.map(d => {
          let isExist = broadcast.find(b => b.id === d.id);
          return !isExist ? broadcast.push(d) : null;
        }),
      );

      return {
        ...state,
        broadcastListing:                broadcastListing,
        getIsResendFailedBroadcast:      true,
        getResendFailedBroadcastPending: false,
        getResendFailedBroadcastError:   null,
      };

    case COMMON_RESEND_FAILED_BROADCAST_FAILURE:
      // The request is failed
      return {
        ...state,
        getResendFailedBroadcastPending: false,
        getResendFailedBroadcastError:   action.data.error,
      };

    case COMMON_RESEND_FAILED_BROADCAST_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getIsResendFailedBroadcast:    false,
        getResendFailedBroadcastError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/resendFailedBroadcast.js